export default "/images/10eba24c78015b30460ab6d02eb5a3b1.avif";